import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { PerfilDossie } from '../models/perfil-dossie.model';
import { DossieRepository, DOSSIER_REPOSITORY } from '../repositories/dossie.repository';

@Injectable({
  providedIn: 'root'
})
export class ListarPerfisDossieUseCase {
  constructor(
    @Inject(DOSSIER_REPOSITORY) private readonly repository: DossieRepository
  ) {}

  execute(): Observable<PerfilDossie[]> {
    return this.repository.listarPerfisDossie();
  }
}

